import { render } from "./Featured.vue?vue&type=template&id=c50ef6ba&scoped=true&ts=true"
import script from "./Featured.vue?vue&type=script&lang=ts"
export * from "./Featured.vue?vue&type=script&lang=ts"

import "./Featured.vue?vue&type=style&index=0&id=c50ef6ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50ef6ba"]])

export default __exports__